<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <path d="M10 0.5C15.523 0.5 20 4.978 20 10.5C20 16.022 15.523 20.5 10 20.5C4.477 20.5 0 16.022 0 10.5C0 4.978 4.477 0.5 10 0.5ZM10 2.167C5.405 2.167 1.667 5.905 1.667 10.5C1.667 15.095 5.405 18.833 10 18.833C14.595 18.833 18.333 15.095 18.333 10.5C18.333 5.905 14.595 2.167 10 2.167ZM9.99866 13.0022C10.5502 13.0022 10.9973 13.4494 10.9973 14.0009C10.9973 14.5524 10.5502 14.9996 9.99866 14.9996C9.44712 14.9996 9 14.5524 9 14.0009C9 13.4494 9.44712 13.0022 9.99866 13.0022ZM9.99446 5.5C10.3742 5.4997 10.6882 5.7816 10.7381 6.14764L10.7451 6.2494L10.7487 10.751C10.749 11.1652 10.4135 11.5013 9.99926 11.5016C9.61957 11.5019 9.30555 11.22 9.25559 10.854L9.24866 10.7522L9.24506 6.2506C9.24473 5.83639 9.58025 5.50033 9.99446 5.5Z" />
  </svg>
</template>
